import React from 'react';
import { Music, Play, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const SpotifySection = () => {
  const spotifyAlbumUrl = 'https://open.spotify.com/album/5627dc2bwRWTo9VCBNKk7O';

  return (
    <section id="music" className="relative py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#1DB954]/10 border border-[#1DB954]/30 rounded-full px-6 py-2 mb-6">
            <Music className="w-5 h-5 text-[#1DB954]" />
            <span className="text-[#1DB954] font-bold text-sm">STREAM NOW</span>
          </div>
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            LISTEN TO
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#1DB954] to-[#1ed760]">
              URBANATION
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Experience the transformative power of gospel and hip-hop fusion on Spotify.
          </p>
        </div>

        {/* Spotify Player Mockup */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#1DB954]/30 rounded-3xl p-8 md:p-12 relative overflow-hidden">
            {/* Decorative gradient */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-[#1DB954]/20 to-transparent rounded-full filter blur-3xl" />
            
            <div className="relative z-10">
              {/* Album Art Mockup */}
              <div className="flex flex-col md:flex-row items-center gap-8 mb-8">
                <div className="w-48 h-48 bg-gradient-to-br from-[#D4AF37] via-[#FFD700] to-[#E63946] rounded-xl flex items-center justify-center transform hover:scale-105 transition-transform duration-300 shadow-2xl shadow-[#D4AF37]/30">
                  <Music className="w-24 h-24 text-[#0a0a0a]" strokeWidth={1.5} />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                    URBANATION
                  </h3>
                  <p className="text-2xl text-[#D4AF37] mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                    40 Songs and a Mic
                  </p>
                  <p className="text-gray-400 mb-6">
                    A powerful collection of gospel and hip-hop tracks that speak truth, hope, and redemption to those who need it most.
                  </p>
                  <Button
                    onClick={() => window.open(spotifyAlbumUrl, '_blank')}
                    className="bg-[#1DB954] hover:bg-[#1ed760] text-white font-bold px-8 py-6 text-lg transition-all duration-300 transform hover:scale-105"
                  >
                    <Play className="w-5 h-5 mr-2 fill-white" />
                    PLAY ON SPOTIFY
                    <ExternalLink className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </div>

              {/* Track List Preview */}
              <div className="bg-[#0a0a0a]/50 border border-[#1DB954]/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  FEATURED TRACKS
                </h4>
                <div className="space-y-3">
                  {[
                    { title: 'The Night Is Long', duration: '3:58', available: true },
                    { title: 'So Many Setbacks', duration: '3:45', available: false },
                    { title: 'ACEs', duration: '4:12', available: false },
                    { title: 'Lost Causes', duration: '4:30', available: false },
                    { title: 'Empathy In Action', duration: '3:22', available: false }
                  ].map((track, index) => (
                    <div key={track.title} className="flex items-center justify-between p-3 rounded-lg hover:bg-[#1DB954]/10 transition-colors cursor-pointer group">
                      <div className="flex items-center space-x-4">
                        <div className="w-8 h-8 bg-[#1DB954]/20 rounded flex items-center justify-center group-hover:bg-[#1DB954]/40 transition-colors">
                          <Play className="w-4 h-4 text-[#1DB954]" />
                        </div>
                        <div>
                          <span className="text-gray-300 group-hover:text-white transition-colors">{index + 1}. {track.title}</span>
                          {!track.available && (
                            <span className="ml-2 text-xs bg-[#E63946]/20 text-[#E63946] px-2 py-1 rounded">Coming Soon</span>
                          )}
                        </div>
                      </div>
                      <span className="text-gray-500 text-sm">{track.duration}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Call to Action */}
              <div className="mt-8 text-center">
                <p className="text-gray-400 text-sm">
                  Every stream supports our rehabilitation programs
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpotifySection;
